<template>
    <DCard
        padding
    >
        <Form
            :product-plan="productPlan"
            :billing-cycles="billingCycles"
            :contract-term-units="contractTermUnits"
            :discount-types="discountTypes"
            :product-id="productId"
            :errors="errors"
            :currency="currency"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Products/ProductPrices/Form'

export default {
    name: 'ProductPriceCreate',
    components: {
        Form
    },
    props: {
        productId: {
            type: Number,
            default: 0
        },
        productPlan: {
            type: Object,
            default () {
                return {}
            }
        },
        billingCycles: {
            type: Array,
            default () {
                return []
            }
        },
        contractTermUnits: {
            type: Array,
            default () {
                return []
            }
        },
        discountTypes: {
            type: Array,
            default () {
                return []
            }
        },
        currency: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('products.products.plans.prices.store', {
                product: this.productId,
                plan: this.productPlan
            }
            ))
        }
    }
}
</script>
